<script setup>
import { toRefs } from "vue";
import TableRow from "./CoursesRow.vue";
import { vElementVisibility } from "@vueuse/components";
import Spinner from "@/components/helpers/Spinner.vue";
import { hasCourseApprover } from "@/composables/authorization.js";

const props = defineProps({
  tableData: {
    type: Array,
    required: true,
    default: () => [],
  },
  isLoading: {
    type: [Boolean, Object],
    required: true,
    default: false,
  },
  shouldShowTable: { type: Boolean, required: true, default: true },
});

const { tableData, isLoading } = toRefs(props);

const emit = defineEmits(["update:currentPage"]);

const handleVisibilityChange = (isVisible) => {
  if (isVisible && tableData?.value?.length && !isLoading.value) {
    emit("update:currentPage");
  }
};
</script>

<template>
  <div v-if="shouldShowTable" class="overflow-x-auto">
    <table class="min-w-full pt-3 table-auto border-collapse">
      <thead class="">
        <tr>
          <th scope="col" class="custom-table-header">Rank</th>
          <th scope="col" class="custom-table-header">Title</th>
          <th scope="col" class="custom-table-header">Host Institution</th>
          <th scope="col" class="custom-table-header">Host Location</th>
          <th scope="col" class="custom-table-header">Host Institution Credits</th>
          <th scope="col" class="custom-table-header">Rec. US Semester Credits</th>
          <th scope="col" class="custom-table-header">
            Description
          </th>
          <th scope="col" class="custom-table-header">Syllabus</th>
          <th scope="col" class="custom-table-header border-r border-gray-300">
            My Equivalent
          </th>
          <th v-if="hasCourseApprover" scope="col" class="custom-table-header">Approvals</th>
        </tr>
      </thead>
      <tbody>
        <TableRow v-for="(row, index) in tableData" :key="index" :row="row" :show-approvals="hasCourseApprover" />
      </tbody>
      <div v-element-visibility="[handleVisibilityChange]" />
    </table>
  </div>
  <Spinner v-if="isLoading" class="pt-4" outer-classes="" />
</template>
<style scoped>
.custom-table-header {
  @apply px-4 py-2 font-semibold text-left text-university-primary;
}
</style>
